import { render, staticRenderFns } from "./PrepClassesSelectbox.vue?vue&type=template&id=b5e34828&"
import script from "./PrepClassesSelectbox.vue?vue&type=script&lang=js&"
export * from "./PrepClassesSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports